import { FeatureFlags } from 'components/common/types/Features.types';
import { PermissionsEnum } from 'consts/permissions';
import { AccessConfigType } from './InsightsAccessConfig.types';

export const ACCESS_CONFIG: AccessConfigType = {
  // temporary feature flag for JCDECAUX-US
  dealHealth: {
    tabs: {
      featureFlags: [FeatureFlags.DEAL_HEALTH_GA],
    },
    labs: {},
  },
  dealHealthChina: {
    tabs: {
      featureFlags: [FeatureFlags.DEAL_HEALTH_CHINA_GA],
    },
    labs: {
      featureFlags: [FeatureFlags.DEAL_HEALTH_CHINA_LABS],
    },
  },
  dealHealthUS: {
    tabs: {
      featureFlags: [FeatureFlags.DEAL_HEALTH_US_GA],
    },
    labs: {
      featureFlags: [FeatureFlags.DEAL_HEALTH_US_LABS],
    },
  },
  proofOfPlayChina: {
    tabs: {
      featureFlags: [FeatureFlags.PROOF_OF_PLAY_CHINA_GA],
    },
    labs: {
      featureFlags: [FeatureFlags.PROOF_OF_PLAY_CHINA_LABS],
    },
  },
  popLiveMonitoring: {
    tabs: {
      featureFlags: [FeatureFlags.POP_LIVE_MONITORING_GA],
    },
    labs: {
      featureFlags: [FeatureFlags.POP_LIVE_MONITORING_LABS],
    },
  },
  revenueInsights: {
    tabs: {
      featureFlags: [FeatureFlags.REVENUE_INSIGHTS_GA],
      permissions: [PermissionsEnum.INSIGHTS_REVENUE_VIEW],
    },
    labs: {
      featureFlags: [FeatureFlags.REVENUE_INSIGHTS_LABS],
      permissions: [PermissionsEnum.INSIGHTS_REVENUE_VIEW],
    },
  },
  inventoryReservation: {
    tabs: {
      featureFlags: [FeatureFlags.INVENTORY_RESERVATION_GA],
      permissions: [PermissionsEnum.INVENTORY_RESERVATION_VIEW],
    },
    labs: {
      featureFlags: [FeatureFlags.INVENTORY_RESERVATION_LABS],
      permissions: [PermissionsEnum.INVENTORY_RESERVATION_VIEW],
    },
  },
};
